import { ILinkDTO, IPaginationDTO } from "@/interface"

export class Pagination {
  public currentPage: number;
  public from: number;
  public to: number;
  public perPage: number;
  public totalRows: number;
  public lastPage: number;
  public firstPageUrl: string;
  public lastPageUrl: string;
  public nextPageUrl: string | null;
  public prevPageUrl?: string | null;
  public links: ILinkDTO[];

  constructor(base?: Partial<Pagination>) {
    if (base) {
      Object.assign(this, base);
    }
  }

  static fromDto(dto: IPaginationDTO) {
    return new Pagination({
      currentPage: +dto.current_page,
      from: +dto.from,
      to: +dto.to,
      perPage: +dto.per_page,
      totalRows: +dto.total,
      lastPage: +dto.last_page,
      firstPageUrl: dto.first_page_url,
      lastPageUrl: dto.last_page_url,
      nextPageUrl: dto.next_page_url,
      prevPageUrl: dto.prev_page_url ? dto.prev_page_url : null,
      links: dto.links,
    });
  }

}
